import { Component, Input, OnInit } from '@angular/core';
import { environment } from "src/environments/environment";

declare const YT: any;

@Component({
    selector: 'app-youtube-player',
    templateUrl: './youtube-player.component.html',
    standalone: false
})
export class YoutubePlayerComponent implements OnInit{

  @Input() videoId: string;
  private player: any;

  constructor() {
    // 1. Asigna la función onYouTubeIframeAPIReady al objeto global window.
    // Esto es necesario para que la API de YouTube pueda llamarla.
    (globalThis as any)['onYouTubeIframeAPIReady'] = () => this.initializePlayer();
  }

  ngOnInit(): void {
    // 2. Comprueba si el script de la API ya está cargado.
    if ((globalThis as any).YT?.Player) {
      this.initializePlayer();
    } else {
      // 3. Si no está cargado, crea y añade el script al body.
      const tag = document.createElement('script');
      tag.src = environment.YOUTUBE_API_URL;
      document.body.appendChild(tag);
    }
  }

  initializePlayer() {
    // 4. Instancia el reproductor de YouTube una vez que la API está lista.
    this.player = new YT.Player('player', {
      height: '100%',
      width: '100%',
      videoId: this.videoId,
    });
  }
}
